import { createApp } from 'vue'
import App from './App.vue'
import store from './utils/store'
import { createPinia } from 'pinia'
import i18n from './lang'
import router from './utils/router';

const app = createApp(App);

app.use(router)
app.use(store)
app.use(i18n)
app.use(createPinia())
app.mount('#app')